import keycloak from "../../keycloak";
import axios from "axios";
import {showError, showInfo} from "../notification/ToastManager";
import config from '../../config'

axios.defaults.withCredentials = true

export async function saveDataModel(dataModel) {
    let header = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + keycloak.token
        }
    }
    return await axios.post(config.BACK_URL + "model", dataModel, header);
}


export async function getAllDataModelsWithStatusPublished() {
    let header = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + keycloak.token
        }
    }
    try {
        let data = null;
        await axios.get(config.BACK_URL + "model/list/PUBLISHED", header).then(response => {
            if (response.status === 200 && response.data.status === 200) {
                data = response.data.content;
                if (data.length === 0) {
                    showInfo("Info", "there is no pemmdb version saved in database");
                }
            } else {
                showError("Error", "An error was occurred when retrieving list pemmdb version as status published");
            }
        })
        return data;
    } catch (e) {
        showError("Error", "An error was occurred when retrieving list published pemmdb version");
        return {
            status: e.response.data.status,
            content: null
        }
    }
}

export async function getModelTags(repository) {
    try {
        return await (await axios.get(
            config.BACK_URL + "git/tags/" + encodeURIComponent(repository),
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + keycloak.token
                }
            }
        )).data
    } catch (e) {
        showError("Error", "An error was occurred when retrieving tags list");
        return {
            status: e.response.data.status,
            content: null
        }
    }
}


export async function getRepositories() {
    try {
        return await (await axios.get(
            config.BACK_URL + "git/repositories",
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + keycloak.token
                }
            }
        )).data
    } catch (e) {
        showError("Error", "An error was occurred when retrieving repository list");
        return {
            status: e.response.data.status,
            content: null
        }
    }
}

export async function searchAllModels() {

    let header = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + keycloak.token
        }
    }
    try {
        let response = {}
        await axios.get(config.BACK_URL + "model/list", header)
            .then(res => {
                if (res.status === 200) {
                    if (res.data.status === 200) {
                        response.status = res.data.status;
                        response.content = res.data.content;
                    } else {
                        showError("Error", "An error was occurred when searching model versions")
                        response = {
                            status: res.data.status,
                            content: null
                        };
                    }
                } else {
                    response = {
                        status: res.data.status,
                        content: null
                    };
                }
            })
        return response;
    } catch (e) {
        showError("Error", "An error was occurred when searching model versions")
    }

}

export async function deleteModelVersion(versionName) {
    let response = null;
    const safePattern = /^[a-zA-Z0-9_.-]+$/;
    const isSafe = safePattern.test(versionName);
    if (!isSafe) return response
    await axios
        .delete(config.BACK_URL + "model/" + encodeURIComponent(versionName), {
            headers: {
                'Content-Type': 'text/plain',
                'Authorization': 'Bearer ' + keycloak.token
            }
        }).then(res => {
            if (res.status === 200) {
                if (res.data.status === 200) {
                    response = res.data.content;
                } else {
                    showError("Error", "A problem was occurred when deleting model version.")
                }
            }
        }).catch(_ => {
            showError("Error", "A problem was occurred when deleting model version.");
        })
    return response;
}

export async function getModelVersion(versionName) {
    let response = null;
    const safePattern = /^[a-zA-Z0-9_.-]+$/;
    const isSafe = safePattern.test(versionName);
    if (!isSafe)
        return {
            status: 500,
            content: null
        }
    await axios
        .get(config.BACK_URL + "model/getVersion/" + versionName, {
            headers: {
                'Content-Type': 'text/plain',
                'Authorization': 'Bearer ' + keycloak.token
            }
        }).then(res => {
            if (res.status === 200) {
                if (res.data.status === 200) {
                    response = res.data.content;
                } else {
                    showError("Error", "A problem was occurred when retreiving model version.")
                }
            }
        }).catch(_ => {
            showError("Error", "A problem was occurred when retreiving model version.");
        })
    return response;
}


export async function previewDataModelAPI(tagName, repository) {
    let options = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + keycloak.token
        },
        responseType: 'arraybuffer'
    }

    const res = await axios
        .get(config.BACK_URL + "model/documentation/preview/" + encodeURIComponent(repository) + "/" + encodeURIComponent(tagName),
            options)
        .catch(_ => {
            showError("Error", "Could not preview data model.");
        })
    return res.data;
}


export async function previewDataModelDocumentationAPI(modelName) {
    let options = {
        headers: {
            'Authorization': 'Bearer ' + keycloak.token
        },
        responseType: 'arraybuffer'
    }
    const res = await axios
        .get(config.BACK_URL + "model/documentation/" + encodeURIComponent(modelName),
            options)
        .catch(_ => {
            showError("Error", "Could not preview data model.");
        })
    return res?.data;
}



export async function getModelNameByDataCollectionName(dataCollectionName) {
    let header = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + keycloak.token
        }
    }

    const res = await axios
        .get(config.BACK_URL + "model/data-collection/" + encodeURIComponent(dataCollectionName), header)
        .catch(_ => {
            showError("Error", "Could not get data model name.");
        })
    return res.data.content;
}
